var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "step_3" } },
    [
      _c("img", { attrs: { src: "" } }),
      _vm._v(" "),
      _c("h2", [_vm._v("What's your shape?")]),
      _vm._v(" "),
      _c("p", [_vm._v("\n    Hover over each shape to see more details.\n  ")]),
      _vm._v(" "),
      _vm._l(_vm.shapes, function (shape) {
        return _c("img_select", { key: shape.Value, attrs: { option: shape } })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }